
import Vue from 'vue';
import NoticeCard from '../NoticeCard/NoticeCard.vue';
/**
- Collapsible in the form of stack
**/
export default Vue.extend<any, any, any, any>({
  name: 'CollapsibleStack',
  components: {
    NoticeCard
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Expand state
     */
    expand: {
      type: Boolean,
      default: false
    },
    /**
     * Set list of stack cards
     */
    stackList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    computedStackList() {
      if (this.expand) {
        return this.stackList;
      }
      return this.stackList.slice(0, 1);
    },
    computedMockStackList() {
      if (this.stackList.length <= 2) {
        return 1;
      }
      return 2;
    }
  },
  methods: {
    handleClick(cardItem: any) {
      /**
       * Method when card is click
       * @event click
       * @type {function}
       */
      this.$emit('click', cardItem);
    }
  }
});
